import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FiX } from "react-icons/fi";

export default function EditTrainerModal({ show, onHide, trainer, onSave }) {
  const [form, setForm] = useState({});

  useEffect(() => {
    setForm(trainer || {});
  }, [trainer]);

  if (!trainer) return null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      backdrop="static"
    >
      {/* HEADER */}
      <div
        style={{
          padding: "16px 20px",
          borderBottom: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h5 style={{ margin: 0, fontWeight: 600 }}>Edit Trainer</h5>

        <div
          onClick={onHide}
          style={{
            width: 30,
            height: 30,
            borderRadius: "50%",
            background: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <FiX />
        </div>
      </div>

      {/* BODY */}
      <Modal.Body style={{ padding: "20px" }}>
        <Form>
          {/* ROW 1 */}
          <div style={{ display: "flex", gap: "15px", marginBottom: 15 }}>
            <div style={{ flex: 1 }}>
              <Form.Label>First Name</Form.Label>
              <Form.Control
                value={form.name?.split(" ")[0] || ""}
                onChange={(e) =>
                  setForm({ ...form, name: e.target.value })
                }
                style={inputStyle}
              />
            </div>

            <div style={{ flex: 1 }}>
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                value={form.name?.split(" ")[1] || ""}
                onChange={(e) =>
                  setForm({ ...form, name: e.target.value })
                }
                style={inputStyle}
              />
            </div>
          </div>

          {/* ROW 2 */}
          <div style={{ display: "flex", gap: "15px", marginBottom: 15 }}>
            <div style={{ flex: 1 }}>
              <Form.Label>Role</Form.Label>
              <Form.Control
                value={form.role || ""}
                onChange={(e) =>
                  setForm({ ...form, role: e.target.value })
                }
                style={inputStyle}
              />
            </div>

            <div style={{ flex: 1 }}>
              <Form.Label>Phone</Form.Label>
              <Form.Control
                value={form.phone || ""}
                onChange={(e) =>
                  setForm({ ...form, phone: e.target.value })
                }
                style={inputStyle}
              />
            </div>
          </div>

          {/* EMAIL */}
          <div style={{ marginBottom: 15 }}>
            <Form.Label>Email</Form.Label>
            <Form.Control
              value={form.email || ""}
              onChange={(e) =>
                setForm({ ...form, email: e.target.value })
              }
              style={inputStyle}
            />
          </div>

          {/* DESCRIPTION */}
          <div style={{ marginBottom: 15 }}>
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={form.description || ""}
              onChange={(e) =>
                setForm({ ...form, description: e.target.value })
              }
              style={inputStyle}
            />
          </div>

          {/* STATUS */}
          <div>
            <Form.Label>Status</Form.Label>
            <Form.Select
              value={form.status || "Active"}
              onChange={(e) =>
                setForm({ ...form, status: e.target.value })
              }
              style={inputStyle}
            >
              <option>Active</option>
              <option>Inactive</option>
            </Form.Select>
          </div>
        </Form>
      </Modal.Body>

      {/* FOOTER */}
      <div
        style={{
          padding: "15px 20px",
          borderTop: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
        }}
      >
        <Button
          onClick={onHide}
          style={{
            background: "#f3f4f6",
            border: "none",
            color: "#374151",
            padding: "8px 18px",
            borderRadius: "6px",
          }}
        >
          Cancel
        </Button>

        <Button
          onClick={() => onSave(form)}
          style={{
            background: "#f97316",
            border: "none",
            padding: "8px 18px",
            borderRadius: "6px",
          }}
        >
          Save Changes
        </Button>
      </div>
    </Modal>
  );
}

// reusable inline style
const inputStyle = {
  background: "#f9fafb",
  border: "1px solid #e5e7eb",
  borderRadius: "6px",
  padding: "10px",
};